import { useFlags } from "launchdarkly-react-client-sdk";
import { useSettingsContext } from "../atlas/contexts/Settings/SettingsContextProvider";
import { FEATURES } from "../constants/features";

export const useSelfInitiatedAssessments = (): boolean => {
  const { enableAtlasAssessmentsUi } = useFlags();
  const { isFeatureEnabled } = useSettingsContext();

  return !!enableAtlasAssessmentsUi && isFeatureEnabled(FEATURES.SELF_ASSESSMENTS);
};
